var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useEffect, useRef } from 'react';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import { useStore } from '../../../../../../store/rootStore';
import { validateEmail } from '../../../../validation';
import { PasswordResetForm, PasswordResetSent } from '.';
import LoginLayout from '../../../LoginLayout';
import s from '../../../../Login.module.scss';
const ForgotPassword = observer(() => {
    const { loginStore } = useStore();
    const history = useHistory();
    const [resetEmail, setResetEmail] = useState('');
    const [resetEmailError, setResetEmailError] = useState();
    const [showResetSent, setShowResetSent] = useState(false);
    const [loading, setLoading] = useState(false);
    const isMountedRef = useRef(true);
    useEffect(() => {
        return () => {
            isMountedRef.current = false;
        };
    }, []);
    const resetDisabled = loading || !resetEmail;
    const sendPasswordResetEmail = (options) => __awaiter(void 0, void 0, void 0, function* () {
        setResetEmailError(undefined);
        if (!(options === null || options === void 0 ? void 0 : options.skipValidation)) {
            const validation = validateEmail(resetEmail);
            if (!validation.isValid) {
                setResetEmailError(validation.error);
                return;
            }
        }
        try {
            setLoading(true);
            const response = yield loginStore.requestPasswordReset(resetEmail);
            if (!isMountedRef.current)
                return;
            if (response && response.success === false) {
                setResetEmailError(response.message || 'Failed to send reset email');
                setLoading(false);
                return;
            }
            setShowResetSent(true);
            setLoading(false);
        }
        catch (e) {
            console.error('Password reset error:', e);
            if (!isMountedRef.current)
                return;
            setResetEmailError((e === null || e === void 0 ? void 0 : e.message) || 'Failed to send reset email');
            setLoading(false);
        }
    });
    const handlePasswordResetSubmit = (e) => {
        e.preventDefault();
        sendPasswordResetEmail();
    };
    const handleResendEmail = () => {
        sendPasswordResetEmail({ skipValidation: true });
    };
    const handleBack = () => {
        history.push('/login');
    };
    return (React.createElement(LoginLayout, { errorMessage: resetEmailError }, showResetSent ? (React.createElement("div", { className: s.pageWrapper },
        React.createElement(PasswordResetSent, { email: resetEmail, onResendEmail: handleResendEmail, onBack: handleBack }))) : (React.createElement("div", { className: s.pageWrapper },
        React.createElement(PasswordResetForm, { onSubmitHandler: handlePasswordResetSubmit, email: resetEmail, setEmail: setResetEmail, loading: loading, disabled: resetDisabled, error: resetEmailError, onBack: handleBack })))));
});
export default ForgotPassword;
